import type { ReconcileResultDto } from '@/api/types/reconciliation';

export function todayIso(): string {
  return toIso(new Date());
}
export function yesterdayIso(): string {
  const d = new Date();
  d.setDate(d.getDate() - 1);
  return toIso(d);
}
export function toIso(d: Date): string {
  const p = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

export interface SectionView {
  assetsValue: number;
  result: number;
  title: string; // EXCESS | SHORTFALL (or "No snapshot available")
  message: string;
}

// Maps a ReconcileResultDto to the right asset/result/title/message trio for a
// given pane (port of applyResult in reconciliation.js).
export function sectionView(
  r: ReconcileResultDto,
  pane: 'int-bank' | 'int-all' | 'ext-bank' | 'ext-all' | 'lp',
): SectionView {
  switch (pane) {
    case 'int-bank':
      return {
        assetsValue: r.bankProvidersBalances,
        result: r.bankProvidersReconcileResult,
        title: r.bankProvidersReconcileResultTitle,
        message: r.bankProvidersReconcileResultMessage,
      };
    case 'int-all':
      return {
        assetsValue: r.cashBookBalanceRc,
        result: r.internalReconcileResult,
        title: r.internalReconcileResultTitle,
        message: r.internalReconcileResultMessage,
      };
    case 'ext-bank':
      return {
        assetsValue: r.bankProvidersBalances,
        result: r.bankProvidersReconcileResult,
        title: r.bankProvidersReconcileResultTitle,
        message: r.bankProvidersReconcileResultMessage,
      };
    case 'ext-all':
      return {
        assetsValue: r.allProvidersBalances,
        result: r.allProvidersReconcileResult,
        title: r.allProvidersReconcileResultTitle,
        message: r.allProvidersReconcileResultMessage,
      };
    case 'lp':
      return {
        assetsValue: r.lpProvidersEquityRc,
        result: r.lpProvidersReconcileResult,
        title: r.lpProvidersReconcileResultTitle,
        message: r.lpProvidersReconcileResultMessage,
      };
  }
}
